import {FC} from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'

const widowTypes = [
  {id: 'none', name: '対象外'},
  {id: 'normal', name: '寡婦（夫）'},
  {id: 'special', name: '特別寡婦'},
]

export const WidowTypes: FC = () => {
  return (
    <MultiTagFilteringFieldRow
      header="寡婦（夫）区分 "
      name="widowTypes"
      list={withNull(widowTypes)}
      shouldUnregister
    />
  )
}
